
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kaupungit/[slug]",
      function () {
        return require("private-next-pages/kaupungit/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kaupungit/[slug]"])
      });
    }
  